export const EquipmentTypeFactory = () => {
    return function EquipmentType() {
        this.id = null;
        this.par_id = null;
        this.code = null;
        this.name = null;
        this.categories = [];
    };
};
